// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "MapSection-module--wrapper--k2YhU";
export var infoWrapper = "MapSection-module--infoWrapper--ig-1c";
export var legendWrapper = "MapSection-module--legendWrapper--pjxxE";